import { formatUploadLimitLabel, maxBytesForScenario } from '@/api/uploadLimitsApi';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.tif', '.tiff'];
const DOCUMENT_EXTENSIONS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt'];
const ALLOWED_EXTENSIONS = [...IMAGE_EXTENSIONS, ...DOCUMENT_EXTENSIONS];

export const CHAT_ATTACHMENT_ACCEPT = ALLOWED_EXTENSIONS.join(',');
export const CHAT_ATTACHMENT_FORMATS = 'PNG/JPG/GIF/WEBP/BMP/TIFF、PDF、DOC/DOCX、XLS/XLSX、TXT';
export const CHAT_ATTACHMENT_HINT = '支持DOC/DOCX/XLS/XLSX';

export const CHAT_ATTACHMENT_MAX_COUNT = 10;
export const CHAT_IMAGE_MAX_COUNT = 10;

function extensionOf(name: string): string {
  const dot = name.trim().lastIndexOf('.');
  return dot >= 0 ? name.trim().slice(dot).toLowerCase() : '';
}

export function isChatImageFile(file: File): boolean {
  return IMAGE_EXTENSIONS.includes(extensionOf(file.name));
}

export function validateChatAttachmentFiles(
  files: File[],
  current: { total: number; images: number },
): string | null {
  const maxBytes = maxBytesForScenario('chat');
  const maxLabel = formatUploadLimitLabel(maxBytes);
  for (const file of files) {
    if (file.size > maxBytes) {
      return `文件「${file.name}」超过 ${maxLabel} 限制`;
    }
    if (!ALLOWED_EXTENSIONS.includes(extensionOf(file.name))) {
      return `文件「${file.name}」格式不支持，仅支持 ${CHAT_ATTACHMENT_FORMATS}`;
    }
  }
  const imageCount = files.filter(isChatImageFile).length;
  if (current.images + imageCount > CHAT_IMAGE_MAX_COUNT) {
    return `图片不超过 ${CHAT_IMAGE_MAX_COUNT} 张`;
  }
  if (current.total + files.length > CHAT_ATTACHMENT_MAX_COUNT) {
    return `附件总数不超过 ${CHAT_ATTACHMENT_MAX_COUNT} 个`;
  }
  return null;
}
